var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[(_vm.isLoading && _vm.isNoData)?_c('div',{staticClass:"item"},[_vm._v("加载中...")]):_vm._e(),(!_vm.isNoData)?_c('div',{staticClass:"item"},[_vm._v("我们也是有底线的~")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }